<template>
    <v-card light>
        <v-card-text>
            <v-form ref="emailVerificationForm" v-model="emailVerificationFormIsValid">
                <page-heading :text="$t(pageTranslationText.title)"></page-heading>
                <div class="mb-3">
                    {{ $t(pageTranslationText.subtitle) }}
                </div>
                <v-row justify="center" no-gutters>
<!--                    v-if="!isTokenLogin"-->
                    <v-col cols="12">
                        <v-text-field :error-messages="errors[0]"
                                      :label="$t('components.verify_email.form_body.email_text_field_label')"
                                      :rules="[validateRule(value.email, $t('general.input_required')), validateRule(validateEmail(value.email), $t('general.valid_email'))]"
                                      :value="value.email"
                                      @input="$emit('email', $event)"
                                      @keyup.enter="emitLogin()"
                                      autocomplete="off"
                                      outlined
                                      ref="emailInput"
                        ></v-text-field>
                    </v-col>
<!--                    <v-col class="text-center my-5" cols="12" v-if="isTokenLogin">-->
<!--                        <small class="error&#45;&#45;text mb-2">{{ errors[0] }}</small>-->
<!--                        <div class="title">{{ $store.state.auth.maskedEmail }}</div>-->
<!--                        <v-btn @click="$emit('logout')" class="secondary&#45;&#45;text" small text>-->
<!--                            {{$t('components.verify_email.form_body.not_my_email')}}-->
<!--                        </v-btn>-->
<!--                    </v-col>-->
                </v-row>
            </v-form>
          <small>
            {{ $t('components.terms.login') }} <a @click="visitTerms()">{{ $t('components.terms.review') }}.</a>
          </small>
        </v-card-text>
        <v-card-actions class="pb-4 px-4 pt-0">
            <v-btn :dark="!loading"
                   :disabled="loading"
                   @click="emitBack()"
                   color="grey"
                   large
                   v-if="!register"
            >{{ withToken ? $t('general.back') : $t('general.quit') }}
            </v-btn>
          <v-btn :dark="!loading"
                 :disabled="loading"
                 @click="emitMobile()"
                 color="secondary"
                 large
                 text
          >{{ $t('components.verify_email.use_mobile') }}
          </v-btn>
            <v-spacer></v-spacer>
            <v-btn :disabled="!emailVerificationFormIsValid"
                   :loading="loading"
                   @click="emitLogin()"
                   color="primary"
                   large
            >{{ $t('general.verify') }}
            </v-btn>
        </v-card-actions>
    </v-card>
</template>

<script>
    import PageHeading from "../framework/PageHeading";

    export default {
        name: "VerifyEmail",
        components: {
            PageHeading
        },
        props: {
            value: {
                type: Object,
                default: null
            },
            loading: {
                type: Boolean,
                default: false
            },
            errors: {
                type: Array,
                default: () => []
            },
            pageTranslationText: {
                required: true,
                type: Object
            },
            isTokenLogin: {
                type: Boolean,
                default: false
            },
            register: {
                type: Boolean
            }
        },
        data: () => ({
            emailVerificationFormIsValid: false,
            withToken: false
        }),
        methods: {
            validateRule(condition, message) {
                return condition ? true : message;
            },
            validateEmail(email) {
                // eslint-disable-next-line no-control-regex
                return /(?:[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-zA-Z0-9-]*[a-zA-Z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/.test(email);
            },
            emitLogin() {
                if (this.$refs.emailVerificationForm.validate()) {
                    this.$emit('login', 'email');
                }
            },
            emitBack() {
                this.$emit('back');
            },
            emitMobile() {
                this.$emit('back');
            },
            visitTerms(){
              window.open('https://fitt.ai/privacy','_blank');
            }
        },
        mounted() {
            this.withToken = location.hash.includes('token');
            setTimeout(()=>{
              this.$refs.emailInput.focus();
            },500);
        }
    }
</script>

<style scoped>

</style>